// extracted by mini-css-extract-plugin
export default {"main":"uploadImagesNew_main__GobtR","title":"uploadImagesNew_title__sQPPA","container":"uploadImagesNew_container__NeXd6","uploadSection":"uploadImagesNew_uploadSection__8Dnsr"};